import React, { PureComponent } from 'react';
import { Button } from 'antd';
import { addGlobalEventListener, sendGlobalEvent } from '../../utils/emit';
import DraggableModal from '../DraggableModal';
import RtcPlayer from './RtcPlayer';
import './player.scss';
import { clstagStr } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
import Resolution, { RESOLUTION } from '../Resolution';

interface Props {
  videoUrl: string;
  maxDelay?: number;
  direction: string;
  zoomable?: boolean;
  handleRecordDelayValue?: AnyFunc;
  isShowOpen?: boolean;
  pushType?: string;
  zoomInClstag?: CLSTAG;
  zoomOutClstag?: CLSTAG;
  showResolution?: boolean;
  onChangeResolution?: (value: RESOLUTION, mesFlag?: boolean) => void;
}
class VideoPlayer extends PureComponent<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      delayTime: '',
    };
  }

  componentDidMount() {
    addGlobalEventListener('CLOSE_ALL_VIDEO_MODAL', this.closeVideoModal);
  }
  openVideoModal = () => {
    if (!this.props.zoomable) {
      return;
    }
    sendGlobalEvent('CLOSE_ALL_VIDEO_MODAL');
    setTimeout(() => {
      this.setState({
        visible: true,
      });
    }, 200);
  };

  closeVideoModal = () => {
    this.setState({
      visible: false,
    });
  };
  render() {
    return (
      <>
        {!this.state.visible ? (
          <div className='video-box'>
            <RtcPlayer {...this.props} />
            <span className='direction'>{this.props.direction}</span>
            {this.props.isShowOpen ? (
              <div
                className='fbox vbox cbox  glass-box'
                onClick={this.openVideoModal}
                clstag={
                  this.props.zoomInClstag && clstagStr(this.props.zoomInClstag)
                }
              >
                <img
                  src={require('../../assets/img/views/single/glass.png')}
                  className='glass'
                ></img>
              </div>
            ) : (
              ''
            )}
            {this.props.showResolution && (
              <Resolution onChange={this.props.onChangeResolution} />
            )}
          </div>
        ) : (
          <div className='message-tip-area'>
            <img
              src={require('../../assets/img/views/single/camera.png')}
              className='camera'
            ></img>
            <span className='open-msg'>{this.props.direction}视频已被放大</span>
            <Button className='close-pop-btn' onClick={this.closeVideoModal}>
              关闭弹窗
            </Button>
          </div>
        )}
        {this.state.visible && (
          <DraggableModal
            className='video-modal'
            title={`实时视频：${this.props.direction}`}
            onClose={this.closeVideoModal}
            clstag={this.props.zoomOutClstag}
          >
            <RtcPlayer {...this.props} videoMode={1} />
          </DraggableModal>
        )}
      </>
    );
  }
}

export default VideoPlayer;
